<template>
  <div class="">
    <div class="comment-box">
      <div class="comment-action">
        <div class="flexmid flexbox">
          <div class="button" @click="getisCommentPopup"><i class="fa fa-comment"></i> {{this.replyList.length}}</div>
          <div :class="praiseClass" @click="addPraise"><i class="fa fa-thumbs-up"></i> {{this.praiseCount}}</div>
        </div>
        <div class="right-des">{{this.praiseCount}}人觉得很赞</div>
      </div>
      <div v-if="replyList.length > 0" class="comment-content">
        <div class="comment-list" v-for="item in replyList" :key="item.id">
          <div class="hd">
            <van-image
              width="100%"
              height="100%"
              fit="cover"
              v-bind:src="item.MemberApiModel.HeadPic"
            />
          </div>
          <div class="bd">
            <div class="cmt-header">
              <div class="user">{{item.MemberApiModel.NickName}}</div>
              <!-- <div v-if="item.ParentMemberApiModel != null && 
                item.MemberApiModel.SerialNumber != item.ParentMemberApiModel.SerialNumber">
                <span style="font-size:8px">评论</span>
                <div class="user">{{item.ParentMemberApiModel.NickName}}</div>
              </div> -->
              <P class="date">{{item.AddDateTime}}</P>
            </div>
            <div class="cmt-body">
              <div v-html="item.Content" class="rich"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 评论弹出 -->
    <van-popup v-model="isCommentPopup" position="bottom">
      <div class="cmt-popup">
        <van-field
          v-model="commentArea"
          ref="commentArea"
          autofocus
          rows="5"
          type="textarea"
          maxlength="150"
          placeholder="请输入您的评论内容"
          @focus="emotionShow = false"
          @blur="emotionShow = false"
        />
        <div class="btmbar">
          <div class="emojiBtn" @click="emotionShow = !emotionShow"><van-icon name="smile-o" size="32" :color="emotionShow ? '#24a378' : '#444' "/></div>
          <van-button size="small" class="mybtn" @click="getMailBoxAddReply">发表</van-button>
        </div>
      </div>
      <div ref="emotionBox">
        <emotion @emotion="handleEmotion" :height="146"  v-if="emotionShow"></emotion>
      </div>
      <!-- <p v-html="commentArea.replace(/\#[\u4E00-\u9FA5]{1,3}\;/gi, emotion)"></p> -->
    </van-popup>
  </div>
</template>

<script>
import Emotion from '@/components/Emotion/index'
import { Toast } from 'vant'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      isCommentPopup : false,
      emotionShow:false,
      commentArea:'',
      praiseClass:{
        'button': true,
        'active' : false,
      },
    }
  },
  computed:{
    ...mapGetters(['currentToken'])
  },
  props:{
    // 评论列表
    replyList:{
      type: Array,
      default:[]
    },
    isPraise:{},// 是否赞了
    praiseCount:{
      type:Number,
    },// 赞的总数
    id:{},
    memorialHallID:{},
    hallCommentMainID:{},
  },
  components: {
    Emotion
  },
  mounted() {
    /*if(this.emotionShow){
      this.$refs.commentArea.focus();
    }else{
      this.$refs.commentArea.blur();
    }*/
  },
  created(){
    this.praiseClass['active'] = this.isPraise;
  },
  methods: {
    handleEmotion (i) {
      this.commentArea += i
    },
    getisCommentPopup(){
      if (this.currentToken.isLogin){
          this.isCommentPopup = true
      }else{
        Toast("匿名不能进行评论,请登录后再进行评论！");
      }
    },
    // 点击赞
    addPraise(){
      if (!this.currentToken.isLogin){
          Toast("匿名不能进行点赞,请登录后再进行点赞！");
          return;
      }
      var _this = this;
      _this.$store.dispatch({
        type: "getMailBoxAddPraise",
        id: _this.id,
      }).then(res =>{
        Toast(res.Message);
        if(res && res.IsSuccess){
          var bl = res.Message.indexOf('取消') > -1;
          if(bl){
            _this.praiseClass['active'] = false;
            _this.$emit('update:praiseCount', _this.praiseCount - 1);
            _this.$emit('update:isPraise', false);
          }else{
            _this.praiseClass['active'] = true;
            _this.$emit('update:praiseCount', _this.praiseCount + 1);
            _this.$emit('update:isPraise', true);
          }
          
        }
      }).catch(ex =>{})

    },
    // 写评论
    getMailBoxAddReply(){
      //
      var _this = this;
        if (_this.commentArea.trim().length<=0){
          Toast("评论内容不能为空!");
          return;
        }
        
        _this.$store.dispatch({
          type:"getMailBoxAddReply",
          "MemorialHallID" : _this.memorialHallID,
          "HallCommentMainID" : _this.hallCommentMainID,
          "Content" : _this.commentArea.replace(/\#[\u4E00-\u9FA5]{1,3}\;/gi, _this.emotion),
        }).then(res => {
          Toast(res.Message);
          if(res.IsSuccess){
            _this.replyList.splice(0,0,res.Information)
            _this.$emit('update:replyList', _this.replyList);
          }
          _this.commentArea = "";
          _this.isCommentPopup = false;
          _this.emotionShow = false;
        }).catch(err => {})
    },
    // 将匹配结果替换表情图片
    emotion (res) {
      // console.log(res);
      let word = res.replace(/\#|\;/gi,'')
      const list = ['微笑', '撇嘴', '色', '发呆', '得意', '流泪', '害羞', '闭嘴', '睡', '大哭', '尴尬', '发怒', '调皮', '呲牙', '惊讶', '难过', '酷', '冷汗', '抓狂', '吐', '偷笑', '可爱', '白眼', '傲慢', '饥饿', '困', '惊恐', '流汗', '憨笑', '大兵', '奋斗', '咒骂', '疑问', '嘘', '晕', '折磨', '衰', '骷髅', '敲打', '再见', '擦汗', '抠鼻', '鼓掌', '糗大了', '坏笑', '左哼哼', '右哼哼', '哈欠', '鄙视', '委屈', '快哭了', '阴险', '亲亲', '吓', '可怜', '菜刀', '西瓜', '啤酒', '篮球', '乒乓', '咖啡', '饭', '猪头', '玫瑰', '凋谢', '示爱', '爱心', '心碎', '蛋糕', '闪电', '炸弹', '刀', '足球', '瓢虫', '便便', '月亮', '太阳', '礼物', '拥抱', '强', '弱', '握手', '胜利', '抱拳', '勾引', '拳头', '差劲', '爱你', 'NO', 'OK', '爱情', '飞吻', '跳跳', '发抖', '怄火', '转圈', '磕头', '回头', '跳绳', '挥手', '激动', '街舞', '献吻', '左太极', '右太极']
      let index = list.indexOf(word)
      return `<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/${index}.gif" align="middle">`   
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

</style>
